module.exports = __webpack_public_path__ + "static/img/M5s.878d8c39.png";